import { Avatar, createStyles, Divider, List, ListItem, ListItemAvatar, ListItemText, makeStyles, Theme, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import React, { useEffect, useState } from 'react'
import { getAllCategories } from '../../../api/api';
import { Category } from '../../../interfaces/tell_me/category.types';
import { CategoryTwoTone, Delete as DeleteIcon, Edit as UpdateIcon, } from '@material-ui/icons';
import CategoryDeleteDialog from './Delete_Dialog';
import CategoryUpdateDialog from './Update_Dialog';
import { useSelector } from 'react-redux';
import { AppState } from '../../../store/store';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        list: {
            backgroundColor: theme.palette.background.paper,
            position: 'relative',
            overflow: 'auto',
            padding: 15,
            maxHeight: '80%',
        },
        root: {
            padding: 10,
            margin: 25,
            minWidth: 1200,
        },
        listSection: {
            backgroundColor: 'inherit',
        },
        ul: {
            backgroundColor: 'inherit',
            padding: 0,
        },
    }),
);

export default function CategoriesScreen() {

    const classes = useStyles();
    const categories = useSelector((state: AppState) => state.categories);

    // Dialog variables
    const [selectedCategory, setSelectedCategory] = useState<Category>();
    const [openUpdateDialog, setUpdateDialog] = useState(false);
    const [openDeleteDialog, setDeleteDialog] = useState(false);

    return (
        <div style={{ paddingBottom: 150, }}>
            <Paper className={classes.root}>

                <h2>Categories</h2>

                <Box />

                <List className={classes.list} >
                    {
                        categories.map((category) => {

                            return (<ListItem id={category.id}>
                                <ListItemAvatar>
                                    <Avatar onClick={() => {
                                        setSelectedCategory(category);
                                        setUpdateDialog(true);
                                    }}>
                                        <UpdateIcon />
                                    </Avatar>
                                </ListItemAvatar>

                                <ListItemAvatar>
                                    <Avatar onClick={() => {
                                        setSelectedCategory(category);
                                        setDeleteDialog(true);
                                    }}>
                                        <DeleteIcon />
                                    </Avatar>
                                </ListItemAvatar>

                                <ListItemText primary={category.name} secondary={" id: " + category.id} />
                                <Typography>
                                    {" Affirmation Count: " + category.affirmations.length}
                                </Typography>
                                <Typography>
                                    {", isPremium: " + category.isPremium}
                                </Typography>
                                <Typography>
                                    {", isActive: " + category.isActive}
                                </Typography>
                                <Typography>
                                    {", lastUpdatedTime: " + new Date(category.lastUpdatedTime ?? 0).toUTCString()}
                                </Typography>
                                <Typography>
                                    {", index: " + category.index + " "}
                                </Typography>
                                <img style={{ width: 120, margin: 15, }} src={category.image} alt={category.name} />
                                <Divider />
                            </ListItem>
                            );
                        })
                    }

                </List>
            </Paper>

            {
                selectedCategory ?
                    <>
                        <CategoryDeleteDialog
                            category={selectedCategory}
                            open={openDeleteDialog}
                            handleClose={() => setDeleteDialog(false)}
                        />
                        <CategoryUpdateDialog
                            category={selectedCategory}
                            open={openUpdateDialog}
                            handleClose={() => setUpdateDialog(false)}
                        />
                    </>
                    :
                    <>
                    </>
            }
        </div >
    );

}